import { createListCollection } from '@chakra-ui/react'
import { PrimitiveAtom, useAtom } from 'jotai'
import { ValueChangeDetails } from 'node_modules/@ark-ui/react/dist/components/select/select'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Select, SelectItem } from '@/components/ui/select'
import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { getGlossariesInfo, getLanguageFullName, glossariesInfoAtom, toggleSelectedGlossary } from '@/store/translate'
import { IGlossaryInfo, ISupportedFromLanguage } from '@/store/translate/dto/glossary.dto'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

const GlossarySelect = () => {
    const { t } = useTranslation()
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)
    const [glossaries, setGlossaries] = useState<IGlossaryInfo[]>([])
    const [selectedSourceLanguageId, setSelectedSourceLanguageId] = useState<string[] | undefined>([''])
    const [glossariesAtom] = useAtom(glossariesInfoAtom)

    useEffect(() => {
        const fetchGlossaries = async () => {
            const data = await getGlossariesInfo()
            if (data) {
                setGlossaries(data)
            }
        }

        if (!glossariesAtom.length) {
            void fetchGlossaries()
        } else {
            setGlossaries(glossariesAtom)
        }
    }, [glossariesAtom])

    if (chatSettings && chatSettings.processingStrategyTranslation.languages.length === 0) {
        return null
    }

    const handleChange = (values: ValueChangeDetails) => {
        const selectedGlossary = values.items.length ? values.items[0] : undefined
        setSelectedSourceLanguageId(selectedGlossary ? values.value : undefined)
        if (selectedGlossary) {
            toggleSelectedGlossary(selectedGlossary.item)
        }
    }

    const collectionItems: Array<{
        value?: string
        label: string
        item?: ISupportedFromLanguage
    }> = [
        {
            value: '',
            label: t('translate.glossarySelect.selectGlossary'),
            item: undefined,
        },
    ]

    for (const glossary of glossaries) {
        for (const sourceLanguage of glossary.supportedFromLanguages) {
            collectionItems.push({
                value: sourceLanguage.glossaryFromLanguageId.toString(),
                label: t('translate.glossarySelect.glossaryLabel', {
                    glossaryName: glossary.glossaryName,
                    sourceLanguage: getLanguageFullName(sourceLanguage.sourceLanguage),
                }),
                item: sourceLanguage,
            })
        }
    }

    const collection = createListCollection({ items: collectionItems })

    return (
        <Select
            aria-valuetext={t('translate.glossarySelect.selectGlossary')}
            placeholder={t('translate.glossarySelect.selectGlossary')}
            value={selectedSourceLanguageId}
            onValueChange={(value) => handleChange(value)}
            collection={collection}
        >
            {collection.items.map((sourceLanguage) => (
                <SelectItem key={sourceLanguage.value} item={sourceLanguage}>
                    {sourceLanguage.label}
                </SelectItem>
            ))}
        </Select>
    )
}

export default GlossarySelect
